/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState } from 'react';
import DropdownItem from 'views/Dashboards-B2B/components/DropdownItem';
import Popover from '@mui/material/Popover';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { CompanyData } from 'api/models/response/CompaniesList';
import * as S from '../../Dashboards-B2B/Dashboard.styled';

type SelectCompanyDropdownProps = {
    selectedCompany: string;
    dashboard: boolean;
    mobile: boolean;
    handleSelectedCompany: (company: CompanyData | string) => void;
    companies: CompanyData | null;
};

const SelectCompanyDropdown = ({
    selectedCompany,
    mobile,
    dashboard,
    handleSelectedCompany,
    companies,
}: SelectCompanyDropdownProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleOptionClick = (
        e: React.MouseEvent<HTMLElement>,
        selection: CompanyData | string
    ) => {
        e.stopPropagation();
        const isAdminPage = window.location.href.includes('admin');
        if (typeof selection === 'string') {
            handleSelectedCompany(t('selectCompany', { lng: language }));
        } else {
            const companyToSelect = isAdminPage ? selection[1] : selection;
            handleSelectedCompany(companyToSelect);
        }
        handleClose();
    };

    return (
        <>
            {companies && (
                <>
                    <S.LeftDropdown
                        mobile={mobile}
                        dashboard={dashboard}
                        isActive={!!anchorEl}
                        onClick={(event) => {
                            handleClick(event);
                        }}
                    >
                        <S.SelectionContainer>{selectedCompany}</S.SelectionContainer>
                        <S.DropdownIcon />
                    </S.LeftDropdown>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        marginThreshold={0}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        slotProps={{
                            paper: {
                                sx: {
                                    overflow: 'visible',
                                    mt: '8px',
                                    minWidth: '7rem',
                                    padding: '0',
                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                                },
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    >
                        <S.DropDownMenu>
                            <DropdownItem onClick={(e) => handleOptionClick(e, 'All')}>
                                {t('all', { lng: language })}
                            </DropdownItem>
                            {Object.entries(companies).map((option: any, i: number) => {
                                return (
                                    <DropdownItem
                                        style={{ display: 'inline-block' }}
                                        key={i}
                                        onClick={(e) => handleOptionClick(e, option)}
                                    >
                                        {option[1]}
                                    </DropdownItem>
                                );
                            })}
                        </S.DropDownMenu>
                    </Popover>
                </>
            )}
        </>
    );
};

export default SelectCompanyDropdown;
